import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'portal-ui-cbs-consent',
  standalone: true,
  imports: [],
  templateUrl: './cbs-consent.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbsConsentComponent {}
